import React, { Component } from 'react'
import { connect }          from 'react-redux'
import moment               from 'moment'
import _                    from 'lodash'
import { withRouter }       from "react-router-dom";
import {
  Form,
  Button,
  Modal,
  Icon,
  Label,
  List,
  Segment,
  Grid,
  Input
} from 'semantic-ui-react'

import utils                from '../../utils'
import firebase             from '../../config/firebase'


class PopularForm extends Component {
  state = {
    fetching: false,
    from: moment().startOf('day').format('x'),
    to: moment().endOf('month').format('x'),
    orderItems: [],
    selectedItems: [],
    hasSearch: false,
    saving: false,
    modalWarning: false
  }

  _onRangeChange(type, value) {
    let newValue

    if (type === 'from') {
      newValue = moment(value).startOf('day').format('x')
    } else {
      newValue = moment(value).endOf('day').format('x')
    }

    this.setState({ [type]: newValue })
  }

  orderItemByQuantity(orderItems) {
    const orderByQty = _.orderBy(orderItems, ['quantity'], ['desc'])

    this.setState({ orderItems: orderByQty.slice(0, 100) })
  }

  filterOrderItems(orders) {
    if (_.size(orders) > 0) {
      const orderValues = Object.values(orders)
      const allOrderItems = {}

      _.map(orderValues, (order) => {
        const restaurantKey = order.restaurant.key
        const restaurantName = order.restaurant.name

        const itemKeys = Object.keys(order.items)

        _.map(itemKeys, (itemKey) => {

          if (allOrderItems[itemKey]) {
            allOrderItems[itemKey] = {
              ...allOrderItems[itemKey],
              quantity: allOrderItems[itemKey].quantity + order.items[itemKey].quantity
            }
          } else {
            allOrderItems[itemKey] = {
              restaurantKey,
              restaurantName,
              itemKey: order.items[itemKey].item_key || itemKey,
              name: order.items[itemKey].name,
              quantity: order.items[itemKey].quantity,
              price: order.items[itemKey].price_at_order,
            }
          }
        })
      })

      this.orderItemByQuantity(allOrderItems)
    }
  }

  handleGeneratedData(orders) {
    const { auth } = this.props
    const deliveredOrders = {}

    orders.forEach((order) => {
      const orderRegion = order.val().region || utils.constants.REGION.PHNOM_PENH

      if (order.val().status === 'delivered' && auth.region === orderRegion) {
        deliveredOrders[order.key] = order.val()
      }
    })

    this.filterOrderItems(deliveredOrders)
  }

  getOrderByRange() {
    const startAt = this.state.from
    const endAt   = this.state.to

    this.setState({ fetching: true })

    firebase
      .database()
      .ref('orders')
      .orderByChild("created_at")
      .startAt(parseInt(startAt, 10))
      .endAt(parseInt(endAt, 10))
      .once('value', snapshot => {
        if (snapshot.val() !== null) {
          this.setState({ fetching: false, hasSearch: true }, () => this.handleGeneratedData(snapshot))
        } else {
          this.setState({ fetching: false, hasSearch: true, orderItems: [] })
        }
      })
  }

  onItemToggle = (itemKey) => {
    const { selectedItems } = this.state

    if (_.includes(selectedItems, itemKey)) {
      this.setState({ selectedItems: _.filter(selectedItems, key => key !== itemKey) })
    } else {
      this.setState({ selectedItems: _.concat(selectedItems, itemKey) })
    }
  }

  isItemActive(itemKey) {
    const { selectedItems } = this.state

    return _.includes(selectedItems, itemKey)
  }

  renderSearchResultRows() {
    const { orderItems } = this.state

    if (_.size(orderItems) > 0) {
      const rows = _.map(orderItems, (item, index) => {
        const isItemActive    = this.isItemActive(item.itemKey)
        const backgroundColor = isItemActive ? { backgroundColor: '#f5f5f5' } : {}

        return (
          <List.Item key={item.itemKey} value={item.itemKey} style={{ padding: '10px 5px 10px 5px', color: 'black', ...backgroundColor }} onClick={() => this.onItemToggle(item.itemKey)}>
            <List.Content style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <div>
                <Label circular style={{ marginRight: 10 }}>{item.quantity}</Label>
              </div>
              <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
                <div>{`${index+1}. ${item.name}`}</div>
                <div style={{ color: 'gray', marginTop: 3 }}>
                  {item.restaurantName}
                </div>
              </div>
              <div>
                { isItemActive && <Icon color='green' name='check' /> }
              </div>
            </List.Content>
          </List.Item>
        )
      })

      return (
        <List divided verticalAlign='middle' selection>
          { rows }
        </List>
      )
    }

    return (
      <List divided verticalAlign='middle'>
        <List.Item style={{ padding: '10px 5px 10px 5px' }}>
          <List.Content style={{ textAlign: "center" }}>
            No Results
          </List.Content>
        </List.Item>
      </List>
    )
  }

  toggleAllSelected() {
    this.setState({ selectedItems: [] })
  }

  renderSelectAll() {
    const { selectedItems, orderItems } = this.state

    if (_.size(orderItems) > 0 && _.size(selectedItems) > 0) {
      return (
        <div>
          <Button onClick={() => this.toggleAllSelected()}>
            Deselect all ({_.size(selectedItems)})
          </Button>
        </div>
      )
    }

    return null
  }

  saveListConfirmation() {
    this.setState({ modalWarning: true })
  }

  renderSearchResults() {
    const { hasSearch, selectedItems } = this.state

    if (hasSearch) {
      return (
        <Grid.Row style={{ paddingTop: 0 }}>
          <Grid.Column>
            <Segment>
              <div style={{ marginBottom: 10 }}>
                <div style={{ height: 40, flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
                  <h4 style={{ height: 40, lineHeight: '40px', marginBottom: 0 }}>
                    Search Results
                  </h4>
                  { this.renderSelectAll() }
                </div>
              </div>
              <div className="popular-items-segment" style={{ height: 'calc(100vh - 370px)', overflowY: 'scroll' }}>
                { this.renderSearchResultRows() }
              </div>
              <div style={{ marginTop: 10, }}>
                <Button disabled={_.size(selectedItems) === 0} color="black" onClick={() => this.saveListConfirmation()}>
                  Save
                </Button>
              </div>
            </Segment>
          </Grid.Column>
        </Grid.Row>
      )
    }

    return null
  }

  saveList() {
    const { auth } = this.props
    const { from: startAt, to: endAt } = this.state

    const self = this

    const filterSelectedItems = this.filterSelectedItemWithValue()
    const listKey = firebase.database().ref('/popular_list').push().key

    const updates = {}
    updates[`/popular_list/${listKey}`] = {
      region: auth.region,
      items: filterSelectedItems,
      status: 'drafted',
      created_at: Date.now(),
      order_query_start_at: parseInt(startAt, 10),
      order_query_end_at: parseInt(endAt, 10)
    }

    this.setState({ saving: true })

    firebase.database().ref().update(updates).then((err) => {
      if (err) { alert(err) }

      self.setState({ saving: false, modalWarning: false, selectedItems: [], orderItems: [] }, () => {
        self.props.history.push({
          pathname: `/advertisement/popular/${listKey}/detail`,
          state: { listKey }
        })
      })
    })
  }

  filterSelectedItemWithValue() {
    const { selectedItems, orderItems } = this.state
    const itemWithValue = {}

    _.map(orderItems, (item, index) => {
      if (_.includes(selectedItems, item.itemKey)) {
        itemWithValue[item.itemKey] = item
      }
    })

    return itemWithValue
  }

  renderWarningContent() {
    const filterSelectedItems = this.filterSelectedItemWithValue()
    const orderByQty = _.orderBy(filterSelectedItems, ['quantity'], ['desc'])

    const rows = _.map(orderByQty, (item, index) => {
      return (
        <List.Item key={item.itemKey} value={item.itemKey} style={{ padding: '10px 5px 10px 5px' }}>
          <List.Content style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div>
              <Label circular style={{ marginRight: 10 }}>{item.quantity}</Label>
            </div>
            <div style={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
              <div>{`${index+1}. ${item.name}`}</div>
              <div style={{ color: 'gray', marginTop: 3 }}>
                {item.restaurantName}
              </div>
            </div>
          </List.Content>
        </List.Item>
      )
    })

    return (
      <List divided verticalAlign='middle'>
        { rows }
      </List>
    )
  }

  renderWarningModal() {
    const { saving, modalWarning } = this.state

    return (
      <Modal
        open={modalWarning}
        style={{ marginTop: 0 }}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>Are you sure to add all this items to list?</Modal.Header>
        <Modal.Content scrolling>
          { this.renderWarningContent() }
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.setState({ modalWarning: false })} disabled={saving}>
            Cancel
          </Button>
          <Button color="black" onClick={() => this.saveList()} loading={saving} disabled={saving}>
            Save
          </Button>
        </Modal.Actions>
      </Modal>
    )
  }

  render() {
    const { fetching, from, to } = this.state

    const startFrom = moment(parseInt(from, 10)).format('YYYY-MM-DD')
    const endAt     = moment(parseInt(to, 10)).format('YYYY-MM-DD')

    return (
      <Form loading={ false }>
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <div style={{ marginTop: 14 }}>
                <div className='capitalize' style={{ display: 'inline-block', marginRight: 10 }}>From</div>
                <Input type="date" value={startFrom} name="from" onChange={(e) => this._onRangeChange('from', e.target.value)} />

                <div className='capitalize' style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>To</div>
                <Input type="date" value={endAt} name="to" onChange={(e) => this._onRangeChange('to', e.target.value)} />

                <Button loading={fetching} disabled={fetching} onClick={() => this.getOrderByRange()} style={{ marginLeft: 10 }}>Get popular items</Button>
              </div>
            </Grid.Column>
          </Grid.Row>
          { this.renderSearchResults() }
        </Grid>
        { this.renderWarningModal() }
      </Form>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  auth: auth.data
})

const mapDispatchToProps = (dispatch) => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PopularForm))



// WEBPACK FOOTER //
// ./src/components/advertisement/popularForm.js